var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddParticipant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.1,13.6v-2.9h-1.5v2.9h-2.9v1.5h2.9V18h1.5v-2.9c0,0,0,0,0,0c0,0,0,0,0,0c1,0,1.9,0,2.9,0h0v-1.5H15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.1,4.2c-0.3-1.5-1.1-2.7-2.5-3.5c-1.5-0.9-3.1-1-4.7-0.3c-1.7,0.8-2.8,2.1-3.1,4C3.6,6,4,7.3,5,8.5 C5.2,8.8,5.4,9,5.7,9.2c0.1,0.1,0.2,0.2,0.3,0.3c-1.7,0.6-3.2,1.7-4.3,3.2C0.6,14.3,0,16,0,18v0h1.5v0c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0.3-2.2,1.4-4,3.3-5.3c1.2-0.8,2.5-1.2,4.1-1.2c0.6,0,1.1-0.1,1.6-0.2 C13.1,9.4,14.6,6.8,14.1,4.2z M12.7,5.2c0,1-0.4,1.9-1.1,2.6C10.9,8.6,10,9,9,9c0,0,0,0,0,0c-2,0-3.7-1.7-3.7-3.7 c0-1,0.4-1.9,1.1-2.6C7,1.9,8,1.5,9,1.5s1.9,0.4,2.6,1.1C12.3,3.3,12.7,4.2,12.7,5.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddParticipant);
export default __webpack_public_path__ + "static/media/addParticipant.610d36f0927d976f19b684299763ee18.svg";
export { ForwardRef as ReactComponent };